import React from 'react'
import { apiFetch } from '../../../../fetchApi'

export const deleteCertificate = ({ BeURL, id, candidateId }) => {
    apiFetch(`${BeURL}/candidate-certificate-delete/${id}/${candidateId}`, {
        method: "DELETE",
        credentials: 'include'
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                alert(data.message)
                window.location.reload()
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log("Error to Delete candidate certificate", err)
        })
}
